import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import ActionButtons from '../../../components/ParametersPage/ActionButtons';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { DownloadMode } from '../../DownloadManager/reducer';

const mapStateToProps = (state: StoreState) => {
	const { downloadManager, driveList, galleryInfos } = state;
	const { items } = downloadManager;
	const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(downloadManager, driveList, galleryInfos);
	const downloadsIds = Object.keys(items);

	let hasDownloadedItems = false;
	downloadsIds.forEach(key => {
		const item = items[key];

		if (!hasDownloadedItems && item.mode !== DownloadMode.Required) {
			hasDownloadedItems = true;
		}
	});

	return {
		hasItemsToDownload,
		hasDownloadedItems,
	};
};

export default connect(mapStateToProps)(ActionButtons);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/ActionButtons/index.tsx